(function () {
    'use strict';

    angular.module('imApp').factory('bankReconciliationsBtService', [
        '$ihttp',
        function ($ihttp) {
            let service = {
                getSetting: function (parms) {
                    return $ihttp.post({
                        method: 3394,
                        parameters: parms || {},
                    });
                },
                unmatchGrid: function (setting) {
                    return $ihttp.post({
                        method: 3396,
                        parameters: setting,
                    });
                },
            };

            return service;
        },
    ]);
})();
